module.exports = __webpack_public_path__ + "img/bulbLeaf.3e3bb4a4.svg";